import * as React from 'react';

import { useQuery } from '@apollo/client';

import S12nRow from 'bundles/internal-enterprise/components/S12nRow';
import specializationPartitionQuery from 'bundles/internal-enterprise/queries/SpecializationPartition.graphql';
import type {
  SpecializationPartitionQuery,
  SpecializationPartitionQueryVariables,
} from 'bundles/internal-enterprise/queries/__generated__/SpecializationPartition';
import type { EnrollItem } from 'bundles/internal-enterprise/types/Program';

type PropsFromCaller = {
  s12nItems: Array<EnrollItem>;
  programId: string;
  userId: string;
};

type Props = PropsFromCaller;

const S12nPartition = ({ s12nItems, programId, userId }: Props) => {
  const { data } = useQuery<SpecializationPartitionQuery, SpecializationPartitionQueryVariables>(
    specializationPartitionQuery,
    {
      variables: {
        ids: s12nItems.map((_) => _.id),
      },
      context: { clientName: 'gatewayGql' },
    }
  );
  const s12ns = data?.Specialization?.queryByIds ?? [];
  return (
    <div className="row-block">
      {s12ns.map((s12n) => {
        const s12nItem = s12nItems.find((item) => item.id === s12n.id);
        return (
          <S12nRow
            s12n={s12n}
            enrolled={s12nItem !== undefined ? s12nItem.enrolled : false}
            programId={programId}
            userId={userId}
          />
        );
      })}
    </div>
  );
};

export default S12nPartition;
